import React from "react";

const Spinner = ({ theme = "default" }) => {
    const themes = {
        default: {
            light: "border-indigo-600",
            dark: "dark:border-gray-400",
        },
        parent: {
            light: "border-[var(--parent-accent)]",
            dark: "dark:border-[var(--parent-border)]",
        },
        // voeg andere thema’s toe indien nodig
    };

    const { light, dark } = themes[theme] || themes.default;

    return (
        <div className="flex justify-center items-center min-h-[100px]">
            <div className={`w-12 h-12 border-4 ${light} ${dark} border-t-transparent rounded-full animate-spin ease-linear`} />
        </div>
    );
};

export default Spinner;